import { Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DELETE, GET } from '../../../utils/requestActionConstants';
import { API_ROUTE, SERVER_ROUTE } from '../../../utils/commonConstants';
import { fetcher, processReq } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addBlog, updateBlog } from '../../../store/slices/blogSlice';
import LexicalEditor from '../../../components/editor/LexicalEditor';
import FileManager from '../../filemanager/FileManager';
import ImageGallery from '../../../components/ImageGallery';
import UploadFile from '../../../components/UploadFile';

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 6,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 18,
        },
    },
};

function AddBlog({ onSwitchTab, tabProps = {} }) {
    const imagesData = useSWR({ method: GET, url: API_ROUTE + '/upload/' }, fetcher);
    const blog = useSelector(state => state.blogSlice.blog);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [blogContent, setBlogContent] = useState(blog.content);

    useEffect(() => {
        loadValues();
    }, [blog]);

    const loadValues = () => {
        if (blog.id) {
            form.setFieldsValue(blog);
            setBlogContent(blog.content);
        } else {
            form.resetFields();
        }
    }


    const onUploadSuccess = (args) => {
        let url = args.url;
        if (!url) return;
        url = SERVER_ROUTE + url

        form.setFieldValue('image', url);
    }

    const saveBlog = (data) => {
        if (blog.id) {
            dispatch(updateBlog({ blogId: blog.id, blogData: data }));
        } else {
            dispatch(addBlog({ blogData: data }));
        }
    }

    const onReload = () => {
        imagesData.mutate();
    }


    const deleteImage = async (file) => {
        if (file.response) {
            let response = await processReq(DELETE, API_ROUTE + "/upload/" + file.response.id);
            onReload();
        } else {
            alert('cannot be deleted');
        }
    }


    return (
        <div className='w-full'>
            <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{blog.id ? "Update blog" : "Add New blog"}</div>
            <div className=' flex'>
                <div>
                    <Form
                        form={form}
                        layout='verticle'
                        {...formItemLayout}
                        style={{
                            // maxWidth: 600,
                            margin: 'auto'
                        }}
                        onFinish={saveBlog}
                    >
                        <Form.Item
                            label="Blog Title"
                            name="title"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter blog title here',
                                },
                            ]}
                            onChange={(event) => {
                                if (!blog.id) {
                                    let generatedSlug = event.target.value.toLowerCase().split(' ').join('-');
                                    form.setFieldValue('slug', generatedSlug);
                                    form.setFieldValue('seoTitle', event.target.value);
                                }
                            }}
                        >
                            <Input placeholder='Title of the blog' />
                        </Form.Item>

                        <Form.Item
                            label="Blog Slug"
                            name="slug"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter blog slug here',
                                },
                            ]}
                        >
                            <Input placeholder='slug-for-the-blog' />
                        </Form.Item>

                        <Form.Item
                            label="SEO Title"
                            name="metaTitle"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter SEO title here',
                                },
                            ]}
                            onChange={(event) => {
                                if (!blog.id) {
                                    let generatedSlug = event.target.value.toLowerCase().split(' ').join('-');
                                    form.setFieldValue('slug', generatedSlug)
                                }
                            }}
                        >
                            <Input placeholder='SEO Title' />
                        </Form.Item>

                        <Form.Item
                            label="Description"
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter blog description here',
                                },
                            ]}
                            onChange={(event) => {
                                if (!blog.id) {
                                    form.setFieldValue('metaDescription', event.target.value);
                                }
                            }}
                        >
                            <Input.TextArea rows={12} placeholder='Add description here' />
                        </Form.Item>

                        <Form.Item
                            label="Meta Description"
                            name="metaDescription"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter meta description here',
                                },
                            ]}
                        >
                            <Input.TextArea rows={12} placeholder='Add meta description here' />
                        </Form.Item>

                        <Form.Item
                            label="Image"
                            name="image"
                            rules={[
                                {
                                    required: true,
                                    message: 'Enter blog banner image here',
                                },
                            ]}
                        >
                            <Input placeholder='Enter blog banner image here' />
                        </Form.Item>
                        <div className='flex w-full m-auto justify-center items-center'>
                            <UploadFile onReload={() => { }} deleteImage={deleteImage} onUploadSuccess={onUploadSuccess} />
                        </div>

                        <Form.Item
                            label="More Content"
                            name="content"
                            rules={[
                                {
                                    required: false,
                                    message: 'Enter more content  ',
                                },
                            ]}
                        >
                            <LexicalEditor
                                initialJSON={blogContent}
                                onChange={json => setBlogContent(json)}
                                placeholder="Write your page content…"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[
                                {
                                    required: true,
                                    message: 'Select Status',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select Status"
                            >
                                <Select.Option value={'Active'}>{'Active'}</Select.Option>
                                <Select.Option value={'Inactive'}>{'Inactive'}</Select.Option>
                            </Select>
                        </Form.Item>


                        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
                            <div className='flex justify-between'>
                                <div>{blog.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
                                <div className='flex'>
                                    <Button danger type='text' htmlType='reset'>Clear</Button>
                                    <Button type='primary' htmlType='submit'>{blog.id ? "Update" : "Save"}</Button>
                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
                <div className='ml-5'>
                    <ImageGallery deleteImage={deleteImage} imagesData={imagesData} />
                </div>
            </div>
        </div>
    )
}

export default AddBlog